<template>
    <div ref="videoContainer" :id="'videoContainer' + videoIdx" class="media-video">
        <video id="player" ref="video" class="video-js"></video>
        <div style="display:none">
            {{source}}
        </div>
    </div>
</template>
<script>
import videojs from "video.js";
import 'video.js/dist/video-js.css';
// HLS Plugin
import "../utils/plugin/videojsHlsPlugin";
// FLV Plugin
import "../utils/plugin/videoFlvPlugin";
// PlayList Plugin
import "../utils/plugin/playlist/playlistPlugin";
// Fmp4 Plugin
import "../utils/plugin/videoFmp4Plugin";


import { CALLBACK_ENUM, makeMessage } from '../utils/enum';
import { hex_md5 } from '../utils/md5';
import { Action } from './toolbar/action';
import { compress, encodePCM, reSampleAndEncodeAudioData, aLawEncode, encodeAudioData, encodePCMA } from './../utils/encode'

window.videojs = videojs;

let playerIndex = 0;
export default {
    name: 'videoJS',
    props: {
        src: String,
        option: {
            type: Object 
        }
    },
    data(){
        return {
            videojs: null,
            source: null,
            videoType: null,
            copyOptions: null,
            videoIdx: null,
      // 语言对讲
      audioContext: null,
      processorNode: null,
      audioSourceNode: null,
      mediaStream: null,
      dataList: [],
      websocket: null,
      wsConnected: false
        }
    },
        computed: {
    ratio: function () {
      // 不太可能出现这种情况，常见的音频设备采样率是 48k 44.1k
      if (!this.audioContext || this.audioContext.sampleRate < 8000) {
        return 1
      }
      return Math.floor(this.audioContext.sampleRate / 8000)
    }
  },
    watch:{
        src(newVal, oldVal){
            this.source = newVal;
            if (this.videojs) {
                this.videoIdx = hex_md5(newVal);
                this.videoType = this.getSourceType(newVal);
                this.videojs.src({
                    src: newVal,
                    type: this.videoType
                });
                // 天津视频特供
                this.videojs.play();
            }
        }
    },
    mounted() {
        // 后续可更改为合并options
        // this.videojs = videojs(this.$refs.video, this.defaultOptions(), this.onReady.bind(this));
        // 监听真实dom级销毁
        this.listenDestory();
    },
    beforeDestroy() {
        this.dispose();
    },
    methods: {
        onReady() {
            console.log('Video Ready!', this.src)
            if (this.src) {
                this.videoType = this.getSourceType(this.src);
                this.videojs.src({
                    src: this.src,
                    type: this.videoType
                });
                // 天津视频特供
                if (this.copyOptions && this.copyOptions.autoplay) {
                    this.videojs.play();
                }
            }
        },
        getSourceType(url) {
            // 简单版本 仅正在判断含hls rtmp
            let reg = /\.m3u8/;
            let flvreg = /\.flv/;
            let mp4reg = /\.mp4/;
            let wsfmp4reg = /(ws|wss):\/\//;
            let sourceType = '';
            if(reg.test(url)){
                sourceType = 'application/x-mpegURL'
            } if(flvreg.test(url)){
                sourceType = 'video/flv'
            } else if(wsfmp4reg.test(url)){
                sourceType = 'video/fmp4'
            } else if(mp4reg.test(url)){
                sourceType = 'video/mp4'
            } else {
                sourceType = 'rtmp/flv';
            }
            return sourceType;
        },
        init() {
            let options = this.defaultOptions();
            if (this.option) {
                options = videojs.mergeOptions(options, this.option);
                this.copyOptions = videojs.mergeOptions(options, this.option);
                console.log('合并Options:option>>',this.option, 'options>>>', options);
            }
            if (this.$refs.video) {
                // 如果该dom已经被初始化之后 进行src切换操作
                if (videojs.getPlayer(this.$refs.video)) {
                    this.videoType = this.getSourceType(this.src);
                    console.log(this.videoType)
                    this.videojs.src({
                        src: this.src,
                        type: this.videoType
                    });
                } else {
                    this.videojs = videojs(this.$refs.video, options, this.onReady.bind(this));
                }
            } else {
                let video = document.createElement('video');
                ++playerIndex;
                video.id = `player${playerIndex}`;
                video.ref = 'video';
                video.className = 'video-js';
                this.$refs.videoContainer.appendChild(video);
                this.$nextTick(()=>{
                    this.videojs = videojs(video, options, this.onReady.bind(this));
                })
            }
            this.videojs && this.videojs.on('fullscreenchange', this.handleFullscreenChange)
        },
        play() {
            this.videojs.play();
        },
        getCore() {
            return this.videojs;
        },
        // 处理组件全屏消息 向外吐出
        handleFullscreenChange() {
            const code = this.$parent.code ? this.$parent.code : ''
            const isFullscreen = this.videojs.isFullscreen() ? 1 : 0;
            this.$parent.$emit('callback', makeMessage(CALLBACK_ENUM.FULL_SCREEN, code, isFullscreen))
        },
        // 截图APi
        screenShot() {
            if (!this.$refs.video) {
                console.error("截图失败，找不到视频对象！")
                return null;
            }
            var canvas = document.createElement("canvas");
            var rect = this.$refs.video.getBoundingClientRect()
            canvas.width = rect.width;
            canvas.height = rect.height;
            canvas.getContext('2d')
                .drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);
            const base64 = canvas.toDataURL();
            return base64;
        },
        // 列表播放
        playMultVideo(playlist, index, startTime) {
            if (!Array.isArray(playlist)) {
                console.warn("请传入播放列表进行播放");
                return -1;
            }
            const reovkePalylist = playlist.map(item=> {
                const sources = [
                    {
                        src: item,
                        type: 'video/mp4'
                    }
                ]
                return {sources};
            })
            let playIndex = index ? index : 0;
            const player = videojs.getPlayer(this.$refs.video);
            console.log(reovkePalylist, playIndex)
            player.playlist(reovkePalylist, playIndex);
            player.playlist.autoadvance(0);
            player.playlist.currentItem();
            // 暂时进行异步 设置播放起始时间
            setTimeout(() => {
                player.currentTime(startTime);
            }, 1000)
        },
        fullscreen(val) {
            // this.isFullscreen = !this.isFullscreen
            if (val === Action.fullscreen) {
                this.videojs && this.videojs.el_ && this.videojs.el_.requestFullscreen()
            } else {
                // EventBus.$emit('toolbar', Action.fullscreen)
                document.exitFullscreen()
            }
        },
        previewBack(startTime, endTime) {

        },
        listenDestory() {
            const MutationObserver =
                window.MutationObserver ||
                window.WebKitMutationObserver ||
                window.MozMutationObserver;
            
            var observerOptions = {
                childList: true,
            }
            // 观察目标子节点的变化，是否有添加或者删除
            var observer = new MutationObserver((mutationsList, observer) => {
                const element = document.getElementById(`videoContainer${this.videoIdx}`);
                if (!element) {
                    this.dispose();
                }
            });
            observer.observe(document.body, observerOptions);
        },
        dispose() {

            // 调用父组件南耀关闭
            if (this.$parent.playNYToken) {
                this.$parent._stopNyPlay();
            }

            if (!this.videojs) {
                return;
            }

            return new Promise((resolve, reject) => {
                if (this.videojs) {
                    this.videojs.dispose();
                }
                this.videojs = null;
                this.$refs.video = null;
                resolve();
            })
        },
        defaultOptions() {
            return {
                controlBar: {
                    playToggle: true,
                    volumePanel: true,
                    progressControl: true,
                    currentTimeDisplay: true,
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: true,
                    playbackRateMenuButton: true
                },
                // fluid:true,
                autoplay: true,
                muted: true,
                language: 'zh-CN',
                live: true,
                hls: true,
                playbackRates: [1,2,4,6,8],
                html5: { 
                    hls: { withCredentials: false },
                    hlsjsConfig: {
                        manifestLoadingTimeOut: 60000,
                        levelLoadingMaxRetry: 10,
                        manifestLoadingMaxRetry: 30,
                        levelLoadingMaxRetryTimeout: 5000
                    }
                },
                flvjs: {
                    mediaDataSource: {
                        cors: true,
                        withCredentials: false,
                        isLive: true
                    },
                },
                poster: '',
                controls: true
            }
        },
    // 语音对讲
    async startVoice(webSrc) {
      console.log('start')
      this.websocket = new WebSocket(webSrc)
      this.websocket.onopen = this.onWebSocketOpen
      this.websocket.onclose = this.onWebSocketClose
      this.websocket.onerror = this.onWebSocketError
      this.mediaStream = await this.getMediaStream()

      await this.makeAudioContextRunning()
      try {
        this.audioSourceNode = this.audioContext.createMediaStreamSource(this.mediaStream)

        // console.log(this.audioContext, this.mediaStream, this.audioSourceNode)

        // 只采集单声道方便处理数据
        this.processorNode = this.audioContext.createScriptProcessor(4096, 1, 1)
        this.audioSourceNode.connect(this.processorNode)
        // sampleRate = 8k & bufferSize = 4096 => 每 0.512s 触发一次 onaudioprocess
        this.processorNode.onaudioprocess = this.onAudioProcess

        this.processorNode.connect(this.audioContext.destination)
      } catch (e) {
        throw new Error('您的浏览器音频相关接口异常，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
    },
    stopVoice() {
      console.log('stop')
      if (this.dataList.length) {
        this.sendAudioData(this.dataList)
        this.dataList = []
      }
      this.releaseResources()
    },
        getMediaStream() {
      // 大部分浏览器有安全限制，http 协议访问的页面 navigator.mediaDevices 也是 undefined， 仅提供 https 服务的可以忽略这个问题
      if (!navigator.mediaDevices) {
        return Promise.reject('您的浏览器不支持获取用户设备，无法使用对讲功能，建议使用 Chrome 浏览器 ( 版本 >= 74 )')
      }
      return navigator.mediaDevices
        .getUserMedia({ audio: { sampleRate: 8000 } })
        .catch(() => Promise.reject('请确保录音设备正常，并允许浏览器获取录音权限，否则无法使用对讲功能'))
    },
       onAudioProcess(event) {
      const lData = event.inputBuffer.getChannelData(0)
      // var l = channelData.length;
      // var buf = new Int16Array(l)

      // while (l--) {
      //     buf[l] = channelData[l]*0xFFFF;    //convert to 16 bit
      // }

      aLawEncode

      encodePCM
      encodePCMA
      encodeAudioData
      // PCMA
      if (this.wsConnected) {
        this.websocket.send(
          encodeAudioData(
            compress(
              {
                left: lData,
                right: []
              },
              48000,
              8000
            )
          )
        )
      }

      return
    },
        async makeAudioContextRunning() {
      // 一般不会出现这种情况，以防万一
      if (!this.audioContext || this.audioContext.state === 'closed') {
        this.audioContext = new AudioContext({
          sampleRate: 8000,
          latencyHint: 'interactive'
        })
      }
      if (this.audioContext.state === 'suspended') {
        await this.audioContext.resume()
      }
    },
    
    releaseResources() {
      if (this.audioSourceNode) {
        this.audioSourceNode.disconnect()
      }
      if (this.processorNode) {
        this.processorNode.disconnect()
      }
      if (this.mediaStream) {
        this.mediaStream.getAudioTracks().forEach((track) => track.stop())
      }
    },
       sendAudioData(dataList) {
      const base64Audio = reSampleAndEncodeAudioData(dataList, 4096, this.ratio)
      // console.log('base64Audio', base64Audio)
      if (this.wsConnected) {
        this.websocket.send(base64Audio)
      }
      // console.log(base64Audio)
    },
        onWebSocketOpen() {
      this.wsConnected = true
    },
    onWebSocketClose() {
      this.wsConnected = false
    },
        onWebSocketError(e) {
      console.error(e)
      this.wsConnected = false
    },
    }
}
</script>
<style lang="scss" scoped>
.media-video {
    width: 100%;
    height: 100%;
}
</style>
<style lang="scss">
.vjs-error .vjs-error-display:before{
    content: none;
}
.video-js .vjs-big-play-button{
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 2.2em;
}
</style>